import React, { useEffect, useState } from "react";

import "react-icons/fi";
// import { useAuth0 } from "@auth0/auth0-react";
import { IntlProvider } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";
import { useNetwork } from "../NetworkProvider";
import MobileProfile from "../LayoutComponents/MobileProfile/MobileProfile";
import NotificationsModal from "../ModalComponents/NotificationsModal";
import NotificationBadge from "../../style/NotificationBadge";
import UserAvatar from "../UserAvatar/UserAvatar";
// import { performLogout } from "../../utils/auth";

import messages_en from "./translations/en.json";
import messages_fr from "./translations/fr.json";

const messages = {
    en: messages_en,
    fr: messages_fr,
};

function Header({
    user,
    isMobileProfileOpen,
    setIsMobileProfileOpen,
    isNotificationsModalOpen,
    setIsNotificationsModalOpen,
}) {
    const location = useLocation();
    const navigate = useNavigate();

    // Get notification state from NetworkProvider
    const {
        notifications,
        newNotifications,
        user: networkUser,
        locale,
        notificationUsers,
    } = useNetwork();

    const [hideHeader, setHideHeader] = useState(false);

    // Use networkUser from NetworkProvider, fallback to prop user for backward compatibility
    const currentUser = networkUser || user;

    // const { logout } = useAuth0();

    useEffect(() => {
        const currentPage = location.pathname;

        // If the path is "client" or if client_id exists in the query string, hide the footer
        if (
            currentPage.split("/")[1] === "settings" ||
            currentPage.split("/")[1] === "lead" ||
            currentPage.split("/")[1] === "clients" ||
            currentPage.split("/")[1] === "client" ||
            currentPage.split("/")[1] === "products" ||
            currentPage.split("/")[1] === "routing"
        ) {
            setHideHeader(true);
        } else {
            setHideHeader(false);
        }
    }, [location]);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const settingsParam = searchParams.get("settings");
        const notificationsParam = searchParams.get("notifications");

        // Handle notifications modal state independently
        if (notificationsParam === "true") {
            setIsNotificationsModalOpen(true);
            setIsMobileProfileOpen(false); // Close mobile profile when notifications is open
        } else {
            setIsNotificationsModalOpen(false);
        }

        // Handle settings modal state
        if (settingsParam === "true" && notificationsParam !== "true") {
            setIsMobileProfileOpen(true);
        } else {
            setIsMobileProfileOpen(false);
        }
    }, [location.search]);

    const handleMobileProfileOpen = () => {
        const params = new URLSearchParams(location.search);
        params.set("settings", "true");
        navigate(`${location.pathname}?${params.toString()}`, {
            replace: true,
        });
    };

    return (
        <IntlProvider messages={messages[locale || "fr"]}>
            <header
                style={{ flexShrink: 0, width: "100%" }}
                className={`text-center text-black z-10 bg-white sticky md:hidden ${
                    hideHeader && "hidden"
                }`}
            >
                <div className="flex flex-row w-full items-center pt-5 pb-5">
                    <div className="flex flex-col items-center w-1/4 rounded-full relative">
                        <NotificationBadge notifications={newNotifications}>
                            <button
                                onClick={handleMobileProfileOpen} // Open the modal on icon click
                                className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center"
                            >
                                <UserAvatar user={currentUser} size="md" />
                            </button>
                        </NotificationBadge>
                    </div>
                    <div className="flex flex-col items-center w-1/2"></div>
                </div>
                {isMobileProfileOpen && (
                    <MobileProfile
                        isOpen={isMobileProfileOpen}
                        setIsModalOpen={setIsMobileProfileOpen}
                        user={currentUser}
                        notifications={notifications}
                        newNotifications={newNotifications}
                        setIsNotificationsModalOpen={
                            setIsNotificationsModalOpen
                        }
                    />
                )}
                {isNotificationsModalOpen && (
                    <NotificationsModal
                        notifications={notifications}
                        notificationUsers={notificationUsers}
                        user_id={currentUser?.user_id}
                        locale={locale || "fr"}
                        isOpen={isNotificationsModalOpen}
                        setIsNotificationsModalOpen={
                            setIsNotificationsModalOpen
                        }
                    />
                )}
            </header>
        </IntlProvider>
    );
}

export default Header;
